import {
  badge_default
} from "../../chunks/chunk.RNJRBJGZ.js";
import "../../chunks/chunk.L4XPMVVI.js";
import "../../chunks/chunk.TUVJKY7S.js";
import "../../chunks/chunk.EVP45OG4.js";
import "../../chunks/chunk.WQC6OWUE.js";
import "../../chunks/chunk.KAW7D32O.js";
export {
  badge_default as default
};
